import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { MarineApiService } from 'src/app/core/services/api/marine-api.service';
import { cities } from '../../models/cities';
import { countries } from '../../models/countries';
import { ProtectionClub } from '../../models/data/protectionClub';


@Component({
  selector: 'app-protection-club-create-edit',
  templateUrl: './protection-club-create-edit.component.html',
  styleUrls: ['./protection-club-create-edit.component.scss']
})
export class ProtectionClubCreateEditComponent implements OnInit {
  public protectionClub: ProtectionClub;
  cities = cities;
  countries = countries;

  @ViewChild('protectionClubsModal') protectionClubsModal;
  @Output() submit: EventEmitter<ProtectionClub> = new EventEmitter<ProtectionClub>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: MarineApiService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(protectionClub: ProtectionClub) {
    this.protectionClub = Object.assign(new ProtectionClub(), protectionClub);
    this.modalRef = this.modalService.open(this.protectionClubsModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.protectionClub.id) {
      this.spinner.show();
      this.api.updateClub(this.protectionClub).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createClub(this.protectionClub).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }

}

